export const partsAllKey = 'partsAll';
export const partsAllListKey = 'partsAllList';
export const partsNoAccountKey = 'partsNoAccount';
export const partsNoAccountListKey = 'partsNoAccountList';
export const getPartsKey = 'getParts';
export const getPartsListKey = 'getPartsList';
export const deletePartsKey = 'deleteParts';
export const editPartsKey = 'editParts';
export const updatePartsKey = 'updateParts';
export const addPartsKey = 'addParts';
